import { Quasar } from "quasar";
const { ssrUpdate } = Quasar;

export default ({ app }) => {
  ssrUpdate({ app });
};
